import { render, staticRenderFns } from "./imgBox.vue?vue&type=template&id=4e4b6f9e&lang=pug"
import script from "./imgBox.vue?vue&type=script&lang=js"
export * from "./imgBox.vue?vue&type=script&lang=js"
import style0 from "./imgBox.vue?vue&type=style&index=0&id=4e4b6f9e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports